import { useDispatch, useSelector } from "react-redux";
import { getPayload } from "../../../selectors/routes.selectors";
import AlertaHistoricoPage from "./AlertaHistoricoPage";
import { useEffect } from "react";
import { actions } from "../../../reducers/cadastro/alertas.actions";
import { getAlertas } from "../../../selectors/cadastro/roteiros.selectors";

const AlertaHistoricoPageConnected = () => {
  const { loading, data } = useSelector(getAlertas);

  const { nomeRoteiro } = data;

  const roteiro = useSelector(getPayload);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      actions.obterAlertas.request({
        pagina: 1,
        idRoteiro: roteiro.id,
      })
    );
  }, [dispatch, roteiro.id]);

  return (
    <AlertaHistoricoPage
      data={data}
      loading={loading}
      nomeRoteiro={nomeRoteiro}
    />
  );
};

export default AlertaHistoricoPageConnected;
